import { descreveFalha } from "./erroMeta";

// O que exibir para um failureReason cru (relatorio de campanha, agendamentos).
// Com codigo da Meta: titulo + acao traduzidos (original fica para o detalhe).
// Sem codigo (ex.: prazo vencido, ja em pt-BR): o texto original e a mensagem.
export const exibeMotivoFalha = failureReason => {
  const d = descreveFalha({ failureReason });
  if (!d.original) return { temCodigo: false, titulo: d.titulo, acao: "", link: null, original: null, resumo: d.titulo };
  if (d.code === null || d.categoria === "desconhecido") {
    return { temCodigo: false, titulo: d.original, acao: "", link: d.link, original: d.original, resumo: d.original };
  }
  return {
    temCodigo: true,
    titulo: d.titulo,
    acao: d.acao,
    link: d.link,
    original: d.original,
    resumo: d.acao ? `${d.titulo}. ${d.acao}` : d.titulo,
  };
};
